import { colors } from '@nhl/common-styled-component';

export const selectControlStyle = {
    borderColor: colors.D2,
    borderRadius: 0,
    minHeight: 38,
    minWidth: 100,
    width: '100%',
};

export const selectOptionStyle = (base, { data, isFocused, isSelected }) => {
    const backgroundColor = isFocused ? '#DEEBFF' : isSelected ? 'rgba(0,126,255,.08)' : base.backgroundColor;
    const color = data.active === false ? colors.$76 : isSelected ? colors.$0 : base.color;
    return {
        ...base,
        backgroundColor,
        color,
    };
};

/* So this is just global styling for ReactSelect
 * Partial application would cause recreating every select on render.
 */
const selectStyles = {
    control: (base) => ({
        ...base,
        ...selectControlStyle,
    }),
    option: selectOptionStyle,
};

export default selectStyles;
